import React, { useState } from "react";
import { HStack, Box, Text, useColorModeValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

interface NavLinksProps {
    scrolled?: boolean;
}

const NavLinks: React.FC<NavLinksProps> = ({ scrolled = false }) => {
    const { t } = useTranslation();
    const textColor = useColorModeValue("#0A1628", "#E8E0D0");

    const navLinks = [
        { label: t("navBaraboutUs"), href: "#aboutUs"  },
        { label: t("navBarProduits"), href: "#Produits" },
        { label: t("navBarServices"), href: "#Services" },
        { label: t("navBarcontact"), href: "#contact"  },
    ];

    return (
        <HStack spacing={{ base: 2, md: 6, lg: 8 }} alignItems="center">
            {navLinks.map((link) => (
                <NavLinkItem
                    key={link.href}
                    href={link.href}
                    label={link.label}
                    textColor={textColor}
                    scrolled={scrolled}
                />
            ))}
        </HStack>
    );
};

const NavLinkItem: React.FC<{
    href: string;
    label: string;
    textColor: string;
    scrolled: boolean;
}> = ({ href, label, textColor, scrolled }) => {
    const [hovered, setHovered] = useState(false);

    return (
        <Box
            as="a"
            href={href}
            position="relative"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{ textDecoration: "none" }}
            pb="2px"
        >
            <Text
                color={textColor}
                fontSize="xs"
                letterSpacing="0.2em"
                textTransform="uppercase"
                fontWeight="400"
                opacity={scrolled ? 0.7 : 0.85}
                transition="opacity 0.3s ease"
                _hover={{ opacity: 1 }}
            >
                {label}
            </Text>

            {/* Underline animé dégradé or → sauge */}
            <motion.div
                animate={{ scaleX: hovered ? 1 : 0, opacity: hovered ? 1 : 0 }}
                transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: "1px",
                    background: "linear-gradient(90deg, #C9A84C, #8B9E6E)",
                    transformOrigin: "left",
                }}
            />
        </Box>
    );
};

export default NavLinks;